import React, { Component } from 'react';
import { Modal, message } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import FormList from '../../../basicElement/FormList';
import './StartTotalModal.less';

class StartTotalModal extends Component {
    state = {
        visible: false,
        params: {},
        loading: false,
        type: 'add',
    }

    show = (record) => {
        const { actualStartSiteAmount, actualRandomAmount, competingCompanyId, companyName: competingCompanyName, competingCompanyManifestationId } = record || {};
        this.setState({
            type:  record ? 'edit' : 'add',
            visible: true,
            params: {
                actualStartSiteAmount,
                actualRandomAmount,
                competingCompanyId,
                competingCompanyName,
                competingCompanyManifestationId
            },
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            params: {},
            loading: false,
            type: 'add',
        });
    }

    handleSubmit = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;
        const { params, type } = this.state;
        const { 
            competingCompanyId,
            actualStartSiteAmount,
            actualRandomAmount,
            competingCompanyManifestationId
        } = params;
        this.setState({ loading: true });
        const url = type == 'add' ? API_URL.competeCompany.submitCompeteCompany : API_URL.competeCompany.updateCompeteCompany;
        const options = {
            method: 'POST',
            url,
            data: {
                competingCompanyId,
                actualStartSiteAmount,
                actualRandomAmount,
                competingCompanyManifestationId
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.props.loadData();
                this.hide();
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        }
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        if (key === 'competingCompanyName') {
            const { text, value: id } = value;
            params.competingCompanyId = id;
            params.competingCompanyName = text;
        } 
        this.setState({
            params,
            hasEdit: true,
        });
    }

    getColumns = () => {
        const { params } = this.state;
        
        const columns = [{
            name: '竞争公司名称',
            key: 'competingCompanyName',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'companyName',
                style: { width: 200 },
                placeholder: '输入公司名称检索',
                params: { limit: 20 },
                url: API_URL.competeCompany.queryCompany,
                config: { id: 'competingCompanyId', name: 'companyName', type: 'competeCompany' },
            },
            rules: {
                required: true,
            }
        },  {
            name: '实际启动总site数',
            key: 'actualStartSiteAmount',
            type: 'inputNumber',
            typeProperty: {
                min: 0,
                precision: 0,
                style: {
                    width: '200px',
                },
            },
            rules: {
                required: true,
            }
        },  {
            name: '实际入组总数',
            key: 'actualRandomAmount',
            type: 'inputNumber',
            typeProperty: {
                min: 0,
                precision: 0,
                style: {
                    width: '200px',
                }
            },
            rules: {
                required: true,
            }
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, children, rules = {} } = column;
                if (children) {
                    traverseColumns(children);
                } else {
                    const typeProperty = column.typeProperty || (column.typeProperty = {});
                    typeProperty.canEdit = true;
                    typeProperty.value = params[key];
                }
            });
        }
        traverseColumns(columns);


        return columns;
    }

    render() {
        const { visible, type } = this.state;
        return (
            <Modal
                title={type == 'add' ? '添加竞争公司启动入组总数' : '修改竞争公司启动入组总数'}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                // className="condition-modal-linear-gradient" 
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width={500}
            >
                <FormList
                    className="form-list registerStartUp-list"
                    columns={this.getColumns()}
                    onChange={this.handleChange}
                    ref={el => this.formRef = el}
                />
        </Modal>
        )
    }
}

export default StartTotalModal;


// WEBPACK FOOTER //
// ./src/components/competeCompany/Performance/components/StartTotalModal.js